(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inline-search"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const closeBtn = event.target.closest(
        '.predictive-search__close-button'
      );

      if (closeBtn) {
        const searchWrapper = document.querySelector(
          '.inline-search-wrapper'
        );
  
        if (searchWrapper) {
          searchWrapper.classList.remove('active');
        }
      }
    });

    // Hide the view all Button untill start the typing
    const searchInput = document.querySelector('.search-input');
    const footer = document.querySelector(
      '.predictive-search-form__footer'
    );

    if (searchInput || footer) {
      footer.style.display = 'none';
  
      searchInput.addEventListener('input', () => {
        footer.style.display =
          searchInput.value.trim() ? 'block' : 'none';
      });
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    // On click search open drawer
  document.addEventListener('DOMContentLoaded', () => {
    const drawer =
      document.getElementById('search-drawer');

    const searchButtons =
      document.querySelectorAll(
        '.search-toggle'
      );

    const closeBtn =
      drawer?.querySelector(
        '.search-drawer__close'
      );

    const overlay =
      drawer?.querySelector(
        '.search-drawer__overlay'
      );

    if (!drawer) {
      console.log(
        'Search drawer not found'
      );
      return;
    }

    // Open drawer
    searchButtons.forEach((button) => {
      button.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();

          console.log(
            'Search button clicked'
          );

          drawer.classList.add(
            'active'
          );

          setTimeout(() => {
            drawer
              .querySelector(
                'input[type="search"]'
              )
              ?.focus();
          }, 100);
        }
      );
    });

    // Close drawer
    const closeDrawer = () => {
      drawer.classList.remove(
        'active'
      );
    };

    closeBtn?.addEventListener(
      'click',
      closeDrawer
    );

    overlay?.addEventListener(
      'click',
      closeDrawer
    );

    document.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape') {
          closeDrawer();
        }
      }
    );
  });
  // search drwaer end
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  // const btn = document.querySelector('.header__column--right .header-mobile-search__button');

  // if (!btn) return;

  // btn.addEventListener('click', function (e) {
  //   e.preventDefault();

  //   const drawer = document.querySelector('#Details-menu-drawer-container');
  //   const summary = drawer?.querySelector(':scope > summary');
  //   const searchWrapper = drawer?.querySelector('.inline-search-mobile');
  //   const searchIcon = document.querySelector('.header__column--right .header-mobile-search__icon');

  //   if (!drawer || !summary || !searchWrapper) return;

  //   // Hide the mobile search icon
  //   searchIcon?.classList.add('is-hidden');

  //   // Open drawer if needed
  //   if (!drawer.open) {
  //     summary.click();
  //   }

  //   // Wait for drawer to open
  //   const waitForOpen = setInterval(() => {
  //     if (drawer.open) {
  //       clearInterval(waitForOpen);

  //       // Show search
  //       searchWrapper.classList.add('is-visible');

  //       // Focus input
  //       const input = searchWrapper.querySelector('.search__input');
  //       input?.focus();
  //       input?.select();
  //     }
  //   }, 20);
  // });

  // Reset when drawer closes
  const drawer = document.querySelector('#Details-menu-drawer-container');

  drawer?.addEventListener('toggle', () => {
    if (!drawer.open) {
      drawer.querySelector('.inline-search-mobile')?.classList.remove('is-visible');
      document
        .querySelector('.header__column--right .header-mobile-search__icon')
        ?.classList.remove('is-hidden');
    }
  });

});
  } catch(e) { console.error(e); }
})();

})();
